module.exports = __webpack_public_path__ + "img/ne.966f2b54.svg";